import axios from '../request';

export default {
  // 获取全部采集设备信息
  getAllDeviceInfo: (params) =>
    axios.get('/engineering/device/devicePull', { params }),
  // 获取全部班组信息
  getAllGroupData: () =>
    axios.post('/staff/group/pulldown'),

  /**
   * PLM 模块接口
  */

  // 获取质量追溯信息
  getCheckHistoryInfo: (params) =>
    axios.post('/m/pipeInfo/checkHistory', params),
  // 查询管片列表
  searchDuctpiecePLMList: (params) =>
    axios({
      method: 'post',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      url: '/m/pipeInfo/findList',
      data: {
        proId: params.proId,
        ringNum: params.ringNum,
        groupId: params.groupId,
        checkResult: params.checkResult,
        reinforcement: params.reinforcement,
        groutingHoles: params.groutingHoles,
        blockNum: params.blockNum,
        inModStartTime: params.inModStartTime,
        inModEndTime: params.inModEndTime,
        pouringStartTime: params.pouringStartTime,
        pouringEndTime: params.pouringEndTime,
        checkStartTime: params.checkStartTime,
        checkEndTime: params.checkEndTime
      }
    }),
  // 添加存在问题信息
  insertIssueInfo: (params) =>
    axios.post('/m/pipeInfo/setscrap', params),
  // 获取存在问题信息
  getProblemInfo: (params) =>
    axios.post('/m/pipeInfo/problemInfo', params),
  // 新增管片信息
  insertPipeData: (params) =>
    axios.post('/m/modcheck/addPipe', params),
  // 修改环号信息
  updataRingNumData: (params) =>
    axios.post('m/pipeInfo/updateRingNum', params),
  // 获取全部钢筋笼与模具信息
  getAllSteelPipeData: (params) =>
    axios.post('/m/steelProduce/ModSteelPullDown', params),
  // 获取时间信息
  getPipeTimeData: (params) =>
    axios.post('/m/pipeInfo/updateDateInfo', params),
  // 修改时间信息
  updatePipeTimeData: (params) =>
    axios.post('/m/pipeInfo/updatePipeDate', params),
  /**
   * 水养模块接口
   * */
  
  // 查询水养信息列表
  searchCisternList: (params) =>
    axios({
      method: 'post',
      url: '/m/waterCultivated/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      }
    }),
  // 添加 修改水养信息
  insertCisternInfo: (params) =>
    axios.post('m/waterCultivated/addWaterCultivated', params),
  // 删除水养池信息
  deleteCisternInfo: (params) =>
    axios.post('/m/waterCultivated/delete', params),
  // 查询水养池实时监控信息
  searchCisternMonitoringList: (params) =>
    axios({
      method: 'post',
      url: '/m/cultivatedDeviceData/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        waterCultivatedId: params.waterCultivatedId,
        deviceId: params.deviceId
      }
    }),
  // 查询水养入池记录
  searchWaterIntoRecord: (params) =>
    axios.post('/m/pipeCultivated/waterRecordRingNum', params),
  // 查询水养出池记录
  searchWaterOutRecord: (params) =>
    axios.post('/m/pipeCultivated/waterRecordRingNumOut', params),
  // 查询水养池水养记录信息
  searchCisternRecordListList: (params) =>
    axios({
      method: 'post',
      url: '/m/pipeCultivated/waterRecordList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        waterCultivatedId: params.waterCultivatedId,
        ringNum: params.ringNum,
        proId:params.proId,
        blockNum: params.blockNum,
        reinforcement: params.reinforcement,
        groutingHoles: params.groutingHoles,
        startTime: params.startTime,
        endTime: params.endTime,
        outCulStartTime: params.outCulStartTime,
        outCulEndTime: params.outCulEndTime
      }
    }),
  // 根据项目查询环号
  getProjectRingNumData: (params) =>
    axios.get('/m/waterCultivated/ringNumList', {params}),
  // 根据项目  环号查询管片信息
  getProjectRingPipeData: (params) =>
    axios.post('/m/pipeCultivated/pipeInfoList', params),
  // 获取水养池下拉
  getWaterCultivatedData: (params) =>
    axios.post('/m/waterCultivated/pulldown', params),
  // 提交入池
  submitpipeEnterCistern: (params) =>
		axios.post('/m/pipeCultivated/intowaterWebs', params),
  // 根据项目查询未入池环号
  getProjectRingNumWaterData: (params) =>
    axios.get('/m/waterCultivated/ringNumListIntoWater', {params}),

  /*
   * 管片蒸养
   */
  // 蒸养窑
  getSegmentSteamInfo: () =>
    axios.post('/m/steam/allSteam'),
  // 管片蒸养列表
  searchSegmentSteam: (params) =>
    axios({
      method: 'post',
      url: '/m/steam/steamData',
      data: params,
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
    }),
    // 管片蒸养导出按钮
  exportSegmentSteam: params =>
        axios({
        method: 'post',
        url: '/engineering/device/steamExport',
        responseType: 'blob',
        data: params
    }),

    /**
     * agv监控
    */
   searchAgvLists: params =>
    axios({
      method: 'post',
      url: '/screen/agvStateHistory/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: params
    }),
  /**
   * 静养区监测
   */
  // 静养区监测列表
  searchConstructionMonitor: (params) =>
    axios.post('/engineering/trestdata/findAll', params),
    // 静养区监测导出按钮
  exportConstructionMonitor: params =>
        axios({
        method: 'post',
        url: '/engineering/trestdata/export',
        responseType: 'blob',
        data: params
    }),


  /**
   * 发运管理中的车辆管理
   */
  // 查询车辆信息
  searchCarInfo: params =>
  axios.post('/engineering/car/carList', params),
  // 添加车辆信息
  insertCarInfo: params =>
    axios.post('/engineering/car/carInsert', params),
  // 修改车辆信息
  updateCarInfo: params =>
    axios.post('/engineering/car/carUpdate', params),
  // 车辆信息详情
  detailsCarInfo: params =>
    axios.get('/engineering/car/carInfo', {params}),
  // 删除车辆信息
  deleteCarInfo: params =>
    axios.get('/engineering/car/carDel', {params}),
  //车辆下拉
  getAllCarInfo: params =>
    axios.get('/engineering/car/carPull', {params}),

  /**
   * 发运管理中的出库管理
   */
  // 查询出库信息
  searchOutInfo: params =>
    axios.post('/materials/pipeOut/pipeOutList', params),
  // 添加出库信息
  insertOutInfo: params =>
    axios.post('/materials/pipeOut/pipeOutInsert', params),
  // 修改出库信息
  updateOutInfo: params =>
    axios.post('/materials/pipeOut/pipeOutUpdate', params),
  // 出库信息详情
  detailsOutInfo: params =>
    axios.get('/materials/pipeOut/pipeOutInfo', {params}),
  // 删除出库信息
  deleteOutInfo: params =>
    axios.get('/materials/pipeOut/pipeOutDel', {params}),
  //收货人下拉框
  getAllReciverInfo: params =>
    axios.get('/engineering/reciver/reciverInfo', {params}),
  //GPS轨迹
  getGpsLine: params =>
    axios.post('/materials/gpsDevice/gpsView', params),
  //发运单上传
  imgUploads: params =>
    axios.post('/materials/pipeOut/pipeOutImg', params),
  //查看发运单详情
  getImgUploadsInfo: params =>
    axios.post('/materials/pipeOut/pipeOutImgInfo', params),
  //获取所有环号
  getAllPipInfos: params =>
    axios.post('/materials/pipeOut/pipeInfoInList', params),

	// 获取堆场下拉信息
	getRepoRecordData: () =>
		axios.post('/m/repoRecord/repoPullDown'),
  // 管片入库
	submitPipePutbankInfo: (params) =>
    axios.post('/m/repoRecord/intoRepoWebs', params),
  // 根据环号查询管片信息
  getProjectRingPipeDatas: (params) =>
    axios.post('/m/pipeCultivated/pipeInfoLists', params),
  // 根据项目查询未入库环号
  getProjectRingNumRepoData: (params) =>
    axios.get('/m/waterCultivated/ringNumListIntoRepo', {params}),
  
  
  /**
   * 发运管理中的GPS设备管理
   */
  // 查询GPS设备信息
  searchGpsDeviceInfo: params =>
    axios({
      method: 'post',
      url: '/materials/gpsDevice/findList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: params
    }),
  // 添加GPS设备信息
  insertGpsDeviceInfo: params =>
    axios.post('/materials/gpsDevice/addGpsDevice', params),
  // 修改GPS设备信息
  updateGpsDeviceInfo: params =>
    axios.post('/materials/gpsDevice/addGpsDevice', params),
  // 删除GPS设备信息
  deleteGpsDeviceInfo: params =>
    axios.post('/materials/gpsDevice/delete', params),
  //GPS设备下拉框
  getGpsDeviceLists: params =>
    axios.post('/materials/gpsDevice/findAll', params),

  /**
   * 堆场管理
   */
  // 查询堆场信息
  searchYardInfo: params =>
  axios.post('/m/repo/findList', params),
  // 添加堆场信息
  insertYardInfo: params =>
    axios.post('/m/repo/addRepo', params),
  //堆场类型下拉框
  yardTypeList: params =>
    axios.post('/m/repo/repoTypePullDown', params),
  // 修改堆场信息
  updateYardInfo: params =>
    axios.post('/m/repo/addRepo', params),
  // 堆场信息单元列表
  cellYardInfo: params =>
    axios.post('/m/repoUnit/unitList', params),
  // 删除堆场信息
  deleteYardInfo: params =>
    axios.post('/m/repo/delete', params),
  //堆场详情信息
  detailsYardInfo: params =>
    axios({
      method: 'post',
      url: '/m/repoRecord/repoDetail',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: params
    }),
  //堆场单元下拉框
  getUnitYardList: params =>
    axios.post('/m/repo/repoUnitPullDown', params),
  //堆场单元删除
  deleteUnitYard: params =>
    axios.post('/m/repo/deleteUnit', params),

  /*
    *质量追溯模块
  */

  // 查询质量追溯列表信息
  searchQualityTracingList: (params) =>
    axios({
      method: 'post',
      url: '/m/checkhis/pipehisList',
      headers: {
        pageNum: params.pageNum,
        pageSize: params.pageSize
      },
      data: {
        ringNum: params.ringNum,
        proId:params.proId
      }
    }),
  // 获取管片详情
  getPipeDetailData: (params) =>
    axios.post('m/checkhis/hisDetail', params),
}